import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Loading, ReceiptNotMor } from '../../../components';
import { fetchReceiptSummary } from '../../../store/actions';
import { StoreState } from '../../../types/store.type';
import { SharedUtils, TranslationUtils } from '../../../utils';
import { LanguageCodes } from '../../../types/preference.type';
import { Guests, Reservation, Stay } from 'guest-data-types-ts-lib';
import { PalReceiptContent } from './PalReceiptContent';
import { QuestionPanel } from './components';

export const PalReceipt: React.FC = () => {
    const dispatch = useDispatch();
    const { trip, user } = useSelector((store: StoreState) => store);
    const { reservation, unit, guests, stay } = trip;
    const receiptSummaryState = useSelector((store: StoreState) => store.receiptSummary);
    const { receiptSummary, error } = receiptSummaryState;

    useEffect(() => {
        if (reservation) {
            dispatch(fetchReceiptSummary(reservation.id));
        }
    }, [reservation?.id, user.currency]);

    if (trip.isLoading || receiptSummaryState.isLoading) {
        return <Loading />;
    }

    const title = TranslationUtils.get('pricing_details');

    const pm = unit?.pms_data?.property_management;

    const renderReceipt = (): any => {
        if (!unit || !reservation || !receiptSummary || !!error) {
            return <ReceiptNotMor />;
        }
        const locale = SharedUtils.getUserLanguageCode(user);
        return (
            <PalReceiptContent
                reservation={reservation as Reservation}
                guests={guests as Guests}
                stay={stay as Stay}
                receiptSummaryResponse={receiptSummary}
                unit={unit}
                locale={locale as LanguageCodes}
            />
        );
    };

    return (
        <Container>
            <h1 tabIndex={0} className="heading-large page-title">
                {title}
            </h1>
            <div className="row">{renderReceipt()}</div>
            <br />
            <div className="mb-4" />
            {pm?.name && (pm?.email || pm?.phone) && (
                <QuestionPanel name={pm.name} email={pm.email ?? undefined} phoneNumber={pm.phone ?? undefined} />
            )}
        </Container>
    );
};
